var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 25 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.9125 8.37187L12.9125 2.37187C12.7892 2.29347 12.6461 2.25183 12.5 2.25183C12.3539 2.25183 12.2108 2.29347 12.0875 2.37187L3.08753 8.37187C2.98296 8.43971 2.89721 8.53285 2.83821 8.64265C2.77922 8.75245 2.74889 8.87536 2.75003 9V18.75C2.75003 19.1478 2.90807 19.5294 3.18937 19.8107C3.47068 20.092 3.85221 20.25 4.25003 20.25H20.75C21.1479 20.25 21.5294 20.092 21.8107 19.8107C22.092 19.5294 22.25 19.1478 22.25 18.75V9C22.2512 8.87536 22.2208 8.75245 22.1618 8.64265C22.1029 8.53285 22.0171 8.43971 21.9125 8.37187ZM9.56566 14.25L4.25003 18V10.4531L9.56566 14.25ZM11.1032 15H13.8969L19.2032 18.75H5.79691L11.1032 15ZM15.4344 14.25L20.75 10.4531V18L15.4344 14.25Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.ab9e3221a11c548b131fe4c077031ceb.svg";
export { ForwardRef as ReactComponent };